import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { PickListDetail, projectStatus, studios } from '@data/pickList/pick-list';
import { Project } from '@data/project/project';
import { ProjectService } from '@data/project/project.service';
import { CommonConstants } from '@mpg-core/constants/common-constants';
import { ConfirmationPopupOption, ConfirmationResponse } from '@shared/common-components/confirmation-popup/confirmation-popup.component';
import { CommonDataService } from '@shared/services/common-data.service';
import { PermissionService } from '@shared/services/permission.service'; // Generated by Copilot
import { NotificationService } from '@shared/services/notification.service';
import { DxTextBoxComponent } from 'devextreme-angular';
import { PublishData, AdminService } from '../services/admin.service';

interface projectSearch{
  projectId:number|null;
  title:string;
}

@Component({
    selector: 'app-manage-projects',
    templateUrl: './manage-projects.component.html',
    styleUrls: ['./manage-projects.component.less'],
    standalone: false
})
export class ManageProjectsComponent implements OnInit {
  selectedItem:any;
  titleList: any;
  showPopup: boolean = false;
  showPublishPopup: boolean = false;
  showRevokePopup: boolean = false;
  popupId: string = '';
  popupType: string = '';
  title: string = '';
  copyTitle: any;
  currentWeekendDate: Date = new Date(
    new Date().setDate(new Date().getDate() - new Date().getDay() + 6)
  );

  isLoading = true;
  openConfirmationPopup: boolean = false;
  confirmationPopupOption: ConfirmationPopupOption;
  isNotifyVisible: boolean = false;
  notifyMessage: any;
  notifyType: string = 'success';
  disAdmin: boolean = false;
  creatingProject=false;
  projectList: Project[] = [];
  statusList: PickListDetail[] = [];
  studioList: PickListDetail[] = [];
  projectId: number;
  isProjectDeleteAllowed: boolean;

  constructor( private commonServices: CommonDataService, private router: Router, private adminService: AdminService, private _proj: ProjectService, private _notify: NotificationService, private permissionService: PermissionService){
    this.openConfirmationPopup=false;
    
    
    // Permission check — use numeric permissionId via PermissionService — Generated by Copilot
    if(this.permissionService.hasReadOnlyAccess('Admin')){
			this.disAdmin=true;
		}
    if (this.commonServices.userInfo.value.userRole.roleId === CommonConstants.SUPER_ADMIN_ROLE_ID){
        this.isProjectDeleteAllowed = true;
      }
  

  }

  searchQuery:string="";
  projectSearchList:projectSearch[]=[];
  noSearchResultText:string="";
  isProjectListDropDownOpened=false;
  selectedCopyProject:projectSearch={
    projectId:null,
    title:''
  };

  @ViewChild("projectSearch") projectSearch: DxTextBoxComponent;

  enableCreate=false;

  enableCreateTitle(){
    if(this.title.trim()!=''){
      this.enableCreate=true;
    }
    else{
      this.enableCreate=false;
    }
  }

  searchProjects(e:any){
    this.searchQuery = e.query;

    this.noSearchResultText="Enter minimum 3 character";

    if(this.searchQuery.length>2){
      this.noSearchResultText="Searching...";
      this.isProjectListDropDownOpened=true;
      this._proj.searchProject(this.searchQuery).subscribe(r=>{
        if(r.status=="SUCCESS" && r.serviceResult){
          this.projectSearchList=r.serviceResult;
        }
        else{
          this.projectSearchList=[];
          this.noSearchResultText="No project found";
        }
      },
      e=>{
        this.noSearchResultText="No project found";
        this.projectSearchList=[];
      }
      );
    }
    else{
      this.noSearchResultText="Enter minimum 3 character";
      this.projectSearchList=[];
    }
  }

  selectProj(e:any){
    this.selectedCopyProject=e.value;
    this.isProjectListDropDownOpened=false;
  }

  confirmCreateProject(){
    let msg="Are you sure about creating project '" + this.title + "' ?";
    if(this.selectedCopyProject.title.trim()!='')
      msg="Are you sure about creating Project '" + this.title + "' ? Project information from '"+ this.selectedCopyProject.title +"' will be copied over to '"+ this.title +"' upon creation";
      // msg="Are you sure about creating Project '" + this.title + "' ? Information from '"+ this.selectedCopyProject.title +"' will be copied over upon creation";
    this.confirmationPopupOption = {
      message: msg,
      rejectButtonText: 'NO',
      normalButtonText: '',
      confirmButtonText: 'YES',
      showCloseButtn: false,
      visible: true,
      option: 'createTitle',
    };
    this.openConfirmationPopup = true;
  }

  ngOnInit(): void {
    this.getAllProjects();
    this.getProjectStatus();
    this.getProjectStudio();
  }

  onResetNotify() {
    this.notifyType = 'success';
    this.notifyMessage = '';
    this.isNotifyVisible = false;
  }


  createProject() {
    if (this.title?.trim()!='') {
      this.creatingProject=true;
      let payload = {
        title:this.title.trim().toUpperCase(),
        isCopyTitleSelected:this.selectedCopyProject.title.trim()!=''? true:false,
        copyProjectId:this.selectedCopyProject.title.trim()!=''? this.selectedCopyProject.projectId:null 
      };
      
      this.adminService.createProject(payload).subscribe((r) => {
        if (r.status == 'SUCCESS' && r.serviceResult) {
            if (r.serviceResult)
              this.router.navigateByUrl(r.serviceResult.toString() + '/report/status-report');
            this.creatingProject=false;
          } 
        }
      );
    }
  }

  getAllProjects() {
    this.adminService.getAllProjects().subscribe(
      (r) => {
        if (r.status == 'SUCCESS'){
          if(r.serviceResult && r.serviceResult.length)
            this.projectList=r.serviceResult;
          else
            this.projectList=[];
        } 
      },
      (e) => {
        if(e.error.status=="SUCCESS"){
          this.projectList=[];
        }
      }
    );
  }

  getProjectStatus(){
    projectStatus.subscribe(r=>{ 
      this.statusList=r; 
    });
  }

  getProjectStudio(){
    studios.subscribe(r=>{ 
      this.studioList=r; 
    });
  }
  

  getDisabledDates(args:any): boolean {
    const dayOfWeek = args.date.getDay();
    const isNotWeekend = dayOfWeek != 6 ;
    return args.view === "month" && (isNotWeekend);
  }

  confirmProjectDeletion(projectTitle: string) {
    this.confirmationPopupOption = {
      message: 'The title '+projectTitle+' has existing budget entries. Deleting it will make its budget data inaccessible.Do you want to proceed ?',
      rejectButtonText: 'NO',
      normalButtonText: '',
      confirmButtonText: 'YES',
      showCloseButtn: false,
      visible: true,
      option: 'confirmDelete',
    };
    this.openConfirmationPopup = true;
  }

  confirmationChanges(res: ConfirmationResponse) {
    this.openConfirmationPopup = false;
    if (res.option == 'confirmDelete' && res.confirmation) {
      this.deleteProject();
    } 
    else if (res.option == 'createTitle' && res.confirmation) {
      this.createProject();
   }
  }

  onProjectRowRemoving(e:any){
    e.cancel=true;
    this.projectId = e.data.projectId;
    this._proj.checkIfBudgetPresentByProject(this.projectId).subscribe(
      r=>{
        if(r.errorCode=="404 NOT_FOUND"){
          this.deleteProject();
        }else {
          this.confirmProjectDeletion(e.data.title);
        }
      }
    );
  }

  deleteProject(){
    this._proj.deleteProject(
      {
        "projectId":this.projectId,
        "isDelete":true
      }
    ).subscribe(
      r=>{
        if(r.status=="SUCCESS"){
          if(r.serviceResult){
            this.projectList.splice(
              this.projectList.findIndex(
                (item) => item.projectId == this.projectId
              ),
              1
            );
          }
        }
      }
            
    );
  }

  ngOnDestroy(){
    this._notify.removeErrorOnTabChange('manage-projects');
  }

}
